/**
 * Created by fd on 2021-09-22 (13:39).
 */
import GameView from "Sources/components/game/views/game-view";
import htmlView from "Views/partials/popup/info-market.html";

require("Styles/components/popup/info-market.scss");

class InfoMarketView extends GameView
{
    constructor(options)
    {
        options.html = $(htmlView);
        super(options);

        this.event = options.event;

        this.secondaryType = options.secondaryType || undefined;
        this.market = options.market || undefined;
    }

    render()
    {
        super.render();

        this.$element.find(".resource-microchip").show();
        this.$element.find(".resource-phone").hide();
        this.$element.find(".resource-bike").hide();

        if (this.secondaryType === "phone")
        {
            this.$element.find(".resource-phone").show();
        }
        else if (this.secondaryType === "bike")
        {
            this.$element.find(".resource-bike").show();
        }

        if (this.market)
        {
            this.$element.find(".market-count-microchip").text(this.market.microchip);
            this.$element.find(".market-count-phone").text(this.market.phone);
            this.$element.find(".market-count-bike").text(this.market.bike);
        }
    }
}

module.exports = InfoMarketView;



// WEBPACK FOOTER //
// ./app/js/components/popup/info-market.js